import type { DehydratedState, VueQueryPluginOptions } from '@peng_kai/kit/libs/vue-query'
import { useState } from '#app'
import { dehydrate, hydrate, VueQueryPlugin } from '@peng_kai/kit/libs/vue-query'
import { queryClient } from '~/query-client'

export default defineNuxtPlugin((nuxt) => {
  const vueQueryState = useState<DehydratedState | null>('vue-query')
  const options: VueQueryPluginOptions = { queryClient }

  nuxt.vueApp.use(VueQueryPlugin, options)

  if (process.server) {
    nuxt.hooks.hook('app:rendered', () => {
      vueQueryState.value = dehydrate(queryClient)
    })
  }

  if (process.client) {
    nuxt.hooks.hook('app:created', () => {
      hydrate(queryClient, vueQueryState.value)
    })
  }
})
